import { React, useState } from "react"
import { useNavigate } from "react-router-dom"
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  UncontrolledButtonDropdown
} from "reactstrap"
import { User, UserPlus, FileText, ShoppingCart } from "react-feather"
import { ANONYMOUS_CLIENT } from "@lib/constants"
import { postDirectSale, postPriceQuote } from "@lib/api"
// ** Custom Components
import RenderModal from "./modal-forms/RenderModal"
import EventForm from "./modal-forms/EventForm"
import AnonymousEventForm from "./modal-forms/AnonymousEventForm"

const QuickActions = () => {
  const [activeModal, setActiveModal] = useState(null)
  const navigate = useNavigate()

  const toggleModal = (id) => {
    if (activeModal !== id) {
      setActiveModal(id)
    } else {
      setActiveModal(null)
    }
  }

  return (
    <>
      <h2 className="text-primary">Create</h2>
      <hr style={{ height: "1px" }} />
      <Label>Select which action you wish to perform</Label>
      <div className="d-flex flex-row align-items-center gap-3">
        <div>
          <Button
            className="d-flex align-items-center"
            color="primary"
            onClick={() => navigate(`/CRM/Create`)}
          >
            <UserPlus style={{ marginRight: "1rem" }} size={20} />
            <span className="fs-5 text-nowrap">New Client</span>
          </Button>
        </div>
        <div>
          <UncontrolledButtonDropdown>
            <DropdownToggle color="info" caret className="text-nowrap" style={{ padding: "14px" }}>
              Anonymous event
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem tag="a" onClick={() => toggleModal("anonymousVisit")}>
                <User size={14} />
                <span className="align-middle ms-50">Anonymous Visit</span>
              </DropdownItem>
              <DropdownItem tag="a" onClick={() => toggleModal("directSale")}>
                <ShoppingCart size={14} />
                <span className="align-middle ms-50">Direct Sale</span>
              </DropdownItem>
              <DropdownItem tag="a" onClick={() => toggleModal("priceQuote")}>
                <FileText size={14} />
                <span className="align-middle ms-50">Price Quote</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </div>
      </div>

      {/* Modal rendering */}
      <RenderModal id="anonymousVisit" toggleModal={toggleModal} activeModal={activeModal}>
        <EventForm
          // onSubmit={getPersonHistoryHandler}
          personId={ANONYMOUS_CLIENT.id}
          eventIdRange={{ min: 50, max: 59 }}
        />
      </RenderModal>
      <RenderModal id="directSale" toggleModal={toggleModal} activeModal={activeModal}>
        <AnonymousEventForm
          onSubmit={postDirectSale}
          title="Direct Sale"
          subtitle="Register a sale done by an anonymous client."
        />
      </RenderModal>
      <RenderModal id="priceQuote" toggleModal={toggleModal} activeModal={activeModal}>
        <AnonymousEventForm
          onSubmit={postPriceQuote}
          title="Price Quote"
          subtitle="Get a price quotation for your anonymous client."
          additionalOptionalFields={["description"]}
        />
      </RenderModal>
    </>
  )
}

export default QuickActions
